import React from 'react';
import { FormField, Label } from '@zillow/constellation-10';

import type { Section } from '../../../../models';
import { FLOODPLAIN } from '../../../../constants';
import YesAndNo from '../../../Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function Floodplain({ section, setSectionValues }: Props) {
  function onNoFloodplain(): void {
    setSectionValues({
      [FLOODPLAIN.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesFloodplain(): void {
    setSectionValues({
      [FLOODPLAIN.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <FormField
      required
      label={<Label>Is the property located in a floodplain or has flooded since 1993?</Label>}
      control={
        <YesAndNo
          yesHandler={onYesFloodplain}
          noHandler={onNoFloodplain}
          yesActive={section.getFieldValue(FLOODPLAIN.FIELD_NAME.IS_ENABLED)}
        />
      }
    />
  );
}

Floodplain.description = 'Kansas City, MO specific flooding screen since 1993';

export default Floodplain;
